import TopHeader from "../../components/TopHeader"
import '../../assets/_prestataire.scss'
import { Link, useNavigate } from "react-router-dom"

const Confirmation=()=>{
    const navigate=useNavigate()
    return(
        <>
        <TopHeader bg={true} btn={true}/>
        <div className="bg-grey d-flex align-items-center">
            <div className="container">
                
            <div className="col-lg-6 mx-auto bg-white text-center p-40 ">
                <img src="/images/checkGreen.svg" alt="check icon" />
                <h3 className="mt-32">Votre compte a bien été créé ! </h3>
                <p className="body mt-16">Vous pourrez retrouver toutes les informations liées à votre compte sur votre espace personnel. Il ne vous reste plus 
                    qu’à remplir votre page établissement pour lancer votre activité.</p>
                <button className="btn twyny-cta-primary w-100 mt-32" onClick={()=>{navigate('/establishmentInfo')}}>Remplir ma page établissement</button>
                <div className="mt-24">
                    <Link to="/compte/prestataire/accueil" className="link-primary mt-24">
                Découvrir mon espace personnel{' '}
                </Link>
                    </div>
            </div>
        </div> 
        </div>
       
        </>
    )

}
export default Confirmation